import React, { useState } from "react";
import styled from "styled-components";
import { Modal, SelectInput, Divider } from "vqp-common";
import { Loading, Button } from "../../common";
import {
  fetchDetailGroups,
  fetchDetailItems,
} from "../../../redux/actions/products";

import useFetch from "../../../utils/useFetch";

const Wrapper = styled.div`
  padding: 30px;
`;

const Title = styled.div`
  font-size: 14px;
`;

const Footer = styled.div`
  text-align: right;
`;

const modalStyle = {
  content: {
    top: "25%",
  },
};

export const DetailSelectModal = ({
  isOpen,
  isItem = false,
  onSelect,
  onClose,
  storeId,
}) => {
  console.log("storeIdstoreIdstoreIdstoreIdstoreId ====>", storeId);

  const details = useFetch(
    !!isItem ? fetchDetailItems : fetchDetailGroups,
    storeId
  );
  const [selectedDetail, setSelectedDetail] = useState();

  const options = details.response
    ? details.response.map((detail) => ({
        name: isItem ? `${detail.code} - ${detail.name}` : detail.name,
        value: detail.id,
      }))
    : [];

  const selectionName = !!isItem ? "Detalhe" : "Grupo de detalhe";

  const handleSelect = () => {
    onSelect(details.response[selectedDetail]);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      style={modalStyle}
      boxWidth={"400px"}
      onClose={onClose}
    >
      <Wrapper>
        <Title>Selecione o {selectionName}</Title>
        {details.loading && <Loading />}
        {details.response && (
          <SelectInput
            options={options}
            selected={selectedDetail}
            onSelect={setSelectedDetail}
            placeholder={selectionName}
          />
        )}
        <Divider marginV={"10px"} />
        <Footer>
          <Button type="button" className="primary" onClick={handleSelect}>
            Selecionar
          </Button>
        </Footer>
      </Wrapper>
    </Modal>
  );
};
